import React, { useLayoutEffect, useRef, useState } from "react";

/**
 * Palco com dimensoes fixas de design (largura x altura) que escala
 * proporcionalmente pra caber na largura do container.
 *
 * Tudo que fica dentro (mockup, canais, linhas SVG) usa o MESMO sistema de
 * coordenadas de design — por isso as conexoes sempre encontram os elementos,
 * em qualquer largura de tela. Sem distorcao: a altura segue o aspect-ratio.
 */
export default function PalcoEscalavel({ largura, altura, className = "", children }) {
  const ref = useRef(null);
  const [escala, setEscala] = useState(0);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const medir = () => setEscala(el.clientWidth / largura);
    medir();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", medir);
      return () => window.removeEventListener("resize", medir);
    }
    const ro = new ResizeObserver(medir);
    ro.observe(el);
    return () => ro.disconnect();
  }, [largura]);

  return (
    <div
      ref={ref}
      className={`relative w-full ${className}`}
      style={{ aspectRatio: `${largura} / ${altura}` }}
    >
      <div
        className="absolute left-0 top-0 origin-top-left"
        style={{
          width: largura,
          height: altura,
          transform: `scale(${escala})`,
          visibility: escala > 0 ? "visible" : "hidden",
        }}
      >
        {children}
      </div>
    </div>
  );
}
